// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"confirm-button_confirmButton__oR2Fw","loading":"confirm-button_loading__XcdwA","shimmer":"confirm-button_shimmer__JOGnE"};